import AppVariables from '../Variables.json';

class ExecutivesReadDto {
	public id: number;

	public name: string;
	public rol: string;
	public area: string;

	public description: string;

	private _imgUrl: string;
	public get imgUrl(): string {
		return this._imgUrl;
	}
	public set imgUrl(value: string) {
		this._imgUrl = AppVariables.BASE_URL + value;
	}
}

export default ExecutivesReadDto;
